import type { Permission } from '@arquivo-morto/contracts';
import type { ComponentType } from 'react';
import { createBrowserRouter, type RouteObject } from 'react-router';
import type { ModuleDef } from '#src/app/navigation/module';
import { MODULES } from '#src/app/navigation/modules';
import {
  ModuleIndex,
  NotFound,
  RequirePermission,
} from '#src/app/navigation/RouteGuards';
import { AppShell } from '#src/app/shell/AppShell';
import { RouteError } from '#src/app/shell/RouteError';
import { HomePage } from '#src/modules/home/HomePage';

/** Página ou rota interna: confere a permissão e só então carrega o código. */
function guardedRoute(
  path: string,
  permission: Permission | undefined,
  load: () => Promise<ComponentType>,
): RouteObject {
  return {
    path,
    element: <RequirePermission permission={permission} />,
    children: [
      { index: true, lazy: async () => ({ Component: await load() }) },
    ],
  };
}

function moduleRoutes(module: ModuleDef): RouteObject {
  return {
    path: module.path,
    children: [
      { index: true, element: <ModuleIndex module={module} /> },
      ...module.pages.map((page) =>
        guardedRoute(page.path, page.permission, page.load),
      ),
      ...(module.routes ?? []).map((route) =>
        guardedRoute(route.path, route.permission, route.load),
      ),
    ],
  };
}

export function createRouter() {
  return createBrowserRouter([
    {
      path: '/',
      element: <AppShell />,
      errorElement: <RouteError />,
      children: [
        { index: true, element: <HomePage /> },
        ...MODULES.map(moduleRoutes),
        { path: '*', element: <NotFound /> },
      ],
    },
  ]);
}
